import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ExploreSection from './ExploreSection';
import SEO from '../components/SEO';

function ExplorePage() {
  return (
    <>
      <SEO
        title="Explore — The PP Studio"
        description="From my background to the work I do — start anywhere. Journey, skills, contract tips, and how to work with me."
        canonical="/explore"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Explore", path: "/explore" }]}
      />
      <Navbar />
      <ExploreSection />
      <Footer />
    </>
  );
}

export default ExplorePage;
